/* 重庆六合彩 */
export default {
  plays: {
    0: {
      rule_id: 42000,
      area_id: 42000,
      play_name: 'TM',
      play_cname: '特码',
      unit_price: 1,
      note_tag: 'lhcMoney',
    },
    1: {
      rule_id: 42001,
      area_id: 42001,
      play_name: 'SX',
      play_cname: '生肖',
      unit_price: 1,
      note_tag: 'lhcMoney',
    },
    2: {
      rule_id: 42002,
      area_id: 42002,
      play_name: 'DXDS',
      play_cname: '大小单双',
      unit_price: 1,
      note_tag: 'lhcMoney',
    },
    3: {
      rule_id: 42003,
      area_id: 42003,
      play_name: 'BS',
      play_cname: '波色',
      unit_price: 1,
      note_tag: 'lhcMoney',
    },
  },
};
